import React from "react";
import { Link } from "react-router-dom";
import { FaCheckCircle, FaSignInAlt } from "react-icons/fa";
import Seo from "../components/Seo";

export default function LoggedOut() {
  return (
    <main className="flex min-h-full items-center justify-center bg-slate-50 px-4 py-12 text-slate-900">
      <Seo title="Logged Out | ClassNX" description="You have been logged out of ClassNX." canonical="/logged-out" robots="noindex, follow" />
      <section className="w-full max-w-md border border-slate-200 bg-white p-8 text-center shadow-xl shadow-slate-200/70 sm:p-10">
        <div className="mx-auto grid h-14 w-14 place-items-center bg-emerald-50 text-2xl text-emerald-600"><FaCheckCircle /></div>
        <p className="mt-6 text-xs font-bold uppercase tracking-[0.18em] text-emerald-600">Session ended</p>
        <h1 className="mt-3 text-3xl font-bold">Logged out successfully</h1>
        <p className="mt-3 text-sm leading-6 text-slate-600">Your ClassNX session has ended. Please log in again to continue.</p>
        <Link to="/login" className="mt-8 inline-flex items-center gap-2 bg-blue-700 px-5 py-3 text-sm font-semibold text-white transition hover:bg-blue-800"><FaSignInAlt /> Log in again</Link>
      </section>
    </main>
  );
}
